"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Projection = void 0;
var proj4_1 = __importDefault(require("proj4"));
var Position_1 = require("../DataModel/Common/Position");
var Vector3_1 = require("../Spatial/Vector3");
var Projection = /** @class */ (function () {
    function Projection(projectionString) {
        this.projection = proj4_1.default(projectionString);
    }
    /** Convert a local coordinate to a global latitude/longitude/altitude value. */
    Projection.prototype.toLatLongCoordinates = function (position) {
        var result = this.projection.inverse({ x: position.x, y: position.y });
        return new Position_1.Position(result.y, result.x, position.z * 3.2808);
    };
    /** Convert a global coordinate to a local map coordinate. */
    Projection.prototype.toLocalCoordinates = function (position) {
        var result = this.projection.forward({ x: position.longitude, y: position.latitude });
        return new Vector3_1.Vector3(result.x, result.y, position.altitude / 3.2808);
    };
    return Projection;
}());
exports.Projection = Projection;
//# sourceMappingURL=Projection.js.map